import React from 'react';
import { motion } from 'framer-motion';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8 }}
    >
      <motion.div
        className="logo-container"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 1.2,
          ease: "easeOut"
        }}
      >
        <motion.img
          src="/LOGO transparent background (1).png"
          alt="The Lida Gallery"
          className="loading-logo"
          initial={{ y: 20 }}
          animate={{ y: 0 }}
          transition={{
            duration: 1,
            ease: "easeOut",
            delay: 0.2
          }}
        />
      </motion.div>
    </motion.div>
  );
};

export default LoadingScreen;



